export interface Route {
    path: string;
    name: string;
    title: string;
    load?: any;
    visibleForSupervisor?: boolean;
}
export interface NavbarRoute extends Route {
    navbar: true;
    iconName: string;
    disabled?: boolean;
}
export interface FallbackRoute {
    default: true;
    title: string;
    name: string;
    load: any;
    path: undefined;
}

export function hasNavbar(route: SomeRoute): route is NavbarRoute {
    return !!(route as NavbarRoute).navbar;
}

export type SomeRoute = Route | NavbarRoute | FallbackRoute;

const routeSettings: SomeRoute[] = [
    {
        path: '/',
        name: 'overview',
        title: 'Overview',
        load: () => import('../views/Overview'),
        navbar: true,
    },
    {
        path: '/daily-log/',
        name: 'dailyLog',
        title: 'Daily Log',
        load: () => import('../views/DailyLog'),
        navbar: true,
    },
    {
        path: '/travel/',
        name: 'travel',
        title: 'Travel',
        load: () => import('../views/Travel'),
        navbar: true,
    },
    {
        path: '/leave/',
        name: 'leave',
        title: 'Leave',
        load: () => import('../views/Leave'),
        navbar: true,
    },
    {
        path: '/timesheet/',
        name: 'timesheet',
        title: 'Timesheet',
        load: () => import('../views/Timesheet'),
        navbar: true,
    },
    {
        path: '/supervise/',
        name: 'supervise',
        title: 'Supervise',
        load: () => import('../views/Supervise'),
        navbar: true,
        visibleForSupervisor: true,
    },
    {
        name: 'fourHundredThree',
        title: '403',
        path: '/403/',
        load: () => import('../views/FourHundredThree'),
    },
    {
        name: 'fourHundredFour',
        title: '404',
        load: () => import('../views/FourHundredFour'),
        default: true,
        path: undefined,
    },
];

export default routeSettings;
